import Toggle from './Toggle';

export default Toggle;


//////////////////
// WEBPACK FOOTER
// ./node_modules/cf-component-toggle/es/index.js
// module id = 29
// module chunks = 0